import { portalApi } from "@services/api/portalApi";
import type { ActiveBannersResponse } from "@godalming/api-types";

export async function getActiveBanners(): Promise<ActiveBannersResponse> {
    try {
        const response = await portalApi.get<ActiveBannersResponse>("/banner/active");
        return response.data;
    } catch (error) {
        throw error;
    }
}
